/**
 * Generated by orval v7.18.0 🍺
 * Do not edit manually.
 * MobiViz
 * The MobiViz API description (multi-version)
 * OpenAPI spec version: 1.0.0
 */
import { fetchApi } from "../../../fetch";
import type {
  JunctionMovementCountsDto,
  JunctionsControllerGetVehicleCountsV0Params,
} from "../../models";

export const getJunctionsControllerGetVehicleCountsV0Url = (
  id: number,
  params: JunctionsControllerGetVehicleCountsV0Params,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v0/junctions/${id}/vehicle-counts?${stringifiedParams}`
    : `/api/v0/junctions/${id}/vehicle-counts`;
};

export const junctionsControllerGetVehicleCountsV0 = async (
  id: number,
  params: JunctionsControllerGetVehicleCountsV0Params,
  options?: RequestInit,
): Promise<JunctionMovementCountsDto> => {
  return fetchApi<JunctionMovementCountsDto>(
    getJunctionsControllerGetVehicleCountsV0Url(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};
